import Typesense from "typesense";

import { getIpAndCountry } from "./getCountry";

const typesense = new Typesense.Client({
  nodes: [
    {
      host: "search.tykr.com",
      port: "443",
      protocol: "https",
    },
  ],
  apiKey: process.env.NEXT_PUBLIC_TYPE_SENSE_API_KEY,
  numRetries: 3,
  connectionTimeoutSeconds: 10,
  retryIntervalSeconds: 0.1,
  healthcheckIntervalSeconds: 2,

  // 'logLevel': 'debug',
});

const typeSenseSearch = async (search, page) => {
  let filterValue = "isActivelyTrading:=true && type:[etf, stock, fund]";

  // const queryParams = {
  //   q: search ? search : "*",
  //   query_by:
  //     "companyName,ticker,exchange,exchangeShortName,country,sector,industry,image,summary",
  //   facet_by:
  //     "newScore,mosPer,share_price,exchange,exchangeShortName,country,sector,industry,summary",
  //   page: page || 1,
  //   per_page: 48,
  //   exhaustive_search: true,
  //   ...(search ? {} : { sort_by: "popularity:desc" }),
  // };

  const queryParams = {
    q: search || "*",
    query_by: "baseSymbol,companyName,exchangeShortName,exchange,country",
    query_by_weights: "10,8,4,2,1",
    num_typos: "0,1,1,1,1",
    prefix: "true,true,false,false,false",
    infix: "always,always,off,off,off",
    text_match_type: "max_score",
    prioritize_token_position: true,
    prioritize_exact_match: true,
    drop_tokens_threshold: 0,
    min_len_1typo: 5,
    min_len_2typo: 8,
    page: page || 1,
    per_page: 30,
    sort_by: "_text_match:desc,popularity:desc"
  };

  const country = localStorage.getItem("country");
  if (!search) {
    if (country) {
      filterValue += ` && country: ${country}`;
    } else {
      const countryData = await getIpAndCountry();
      const filterString = countryData?.countryCode;
      if (filterString) {
        localStorage.setItem("country", filterString);
        filterValue += ` && country: ${filterString}`;
      }
    }
  }

  if (filterValue) {
    queryParams["filter_by"] = filterValue;
  }

  const searchResult = await typesense
    .collections(process.env.NEXT_PUBLIC_TYPE_SENSE_COLLECTION)
    .documents()
    .search({ ...queryParams });

  return searchResult;
};

export default typeSenseSearch;
